<template>
  <div class="relative bg-white pt-2 pb-2">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div class="flex flex-wrap mt-6">
        <div class="w-full px-4">
          <div
            class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white"
          >
            <div class="rounded-t mb-0 px-6 py-3 border-0">
              <div class="flex flex-wrap items-center">
                <div class="relative w-full px-4 max-w-full flex-grow flex-1">
                  <h3 class="font-semibold text-base text-blueGray-700">
                    支付订单列表
                  </h3>
                </div>
              </div>
            </div>
            <div class="block w-full px-6 pb-6">
              <el-form
                :inline="true"
                :model="searchParams"
                class="demo-form-inline"
              >
                <el-form-item label="Unionid">
                  <el-input
                    v-model="searchParams.unionid"
                    placeholder="请输入 Unionid"
                  ></el-input>
                </el-form-item>
                <el-form-item label="订单号">
                  <el-input
                    v-model="searchParams.orderNo"
                    placeholder="请输入订单号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="订单状态">
                  <el-select
                    v-model="searchParams.status"
                    clearable
                    placeholder="请选择订单状态"
                    style="width: 160px"
                  >
                    <el-option label="待支付" value="1"></el-option>
                    <el-option label="已支付" value="2"></el-option>
                    <el-option label="已退款" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="开始时间">
                  <el-date-picker
                    v-model="searchParams.startTime"
                    type="datetime"
                    placeholder="开始时间"
                    format="YYYY-MM-DD HH:mm"
                    value-format="x"
                    style="width: 220px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="截止时间">
                  <el-date-picker
                    v-model="searchParams.endTime"
                    type="datetime"
                    placeholder="截止时间"
                    format="YYYY-MM-DD HH:mm"
                    value-format="x"
                    style="width: 220px"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button @click="resetSearch">重置</el-button>
                </el-form-item>
              </el-form>
              <div class="block w-full overflow-x-auto">
                <el-table
                  :data="orders"
                  style="width: 100%; min-width: 1500px"
                  :default-sort="{ prop: 'createdAt', order: 'descending' }"
                  stripe
                  border
                  highlight-current-row
                >
                  <el-table-column label="订单号" width="260">
                    <template #default="scope">
                      <p class="text-sm font-semibold">
                        平台商户单号：{{ scope.row.orderId || "-" }}
                      </p>
                      <p class="text-xs text-gray-600">
                        微信商户单号：{{ scope.row.wxOrderId || "-" }}
                      </p>
                      <p class="text-xs text-gray-500">
                        交易单号：{{ scope.row.transactionId || "-" }}
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column label="Unionid/手机号" width="220">
                    <template #default="scope">
                      <p class="text-sm text-gray-700">
                        {{ scope.row.unionid || "-" }}
                      </p>
                      <p class="text-xs text-gray-500">
                        {{ scope.row.mobile || "-" }}
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column label="支付金额" width="120">
                    <template #default="scope">
                      <p class="text-sm font-semibold text-green-600">
                        ¥{{ scope.row.amount }}
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column label="支付方式" width="120">
                    <template #default="scope">
                      <el-tag
                        :type="getPaymentMethodTagType(scope.row.paymentMethod)"
                        size="small"
                      >
                        {{ getPaymentMethodLabel(scope.row.paymentMethod) }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column label="商品信息" width="180">
                    <template #default="scope">
                      <p class="text-sm">{{ scope.row.productName }}</p>
                      <p class="text-xs text-gray-500">
                        {{ scope.row.productType }}
                      </p>
                    </template>
                  </el-table-column>

                  <el-table-column label="支付归因" width="180">
                    <template #default="scope">
                      <p class="text-sm">{{ scope.row.factor }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="createdAt"
                    label="创建时间"
                    width="180"
                    sortable
                  >
                    <template #default="scope">
                      {{ formatDate(scope.row.createdAt * 1000) }}
                    </template>
                  </el-table-column>

                  <el-table-column label="状态" width="100">
                    <template #default="scope">
                      <el-tag
                        :type="getStatusTagType(scope.row.status)"
                        size="small"
                      >
                        {{ getStatusLabel(scope.row.status) }}
                      </el-tag>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="paidAt"
                    label="支付时间"
                    width="180"
                    sortable
                  >
                    <template #default="scope">
                      {{ scope.row.paidAt }}
                    </template>
                  </el-table-column>

                  <el-table-column label="操作" fixed="right">
                    <template #default="scope">
                      <el-button
                        type="primary"
                        size="small"
                        @click="viewOrder(scope.row)"
                      >
                        查看
                      </el-button>
                      <el-button
                        v-if="scope.row.status === 'pending'"
                        type="success"
                        size="small"
                        @click="markAsPaid(scope.row)"
                      >
                        标记已支付
                      </el-button>
                      <el-button
                        v-if="scope.row.status === 'pending'"
                        type="danger"
                        size="small"
                        @click="cancelOrder(scope.row)"
                      >
                        取消订单
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination
                class="payment-pagination"
                background
                :current-page="currentPage"
                :page-size="itemsPerPage"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalRecords"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Detail Modal -->
    <el-dialog
      v-model="showModal"
      title="订单详情"
      width="600px"
      :before-close="closeModal"
      class="responsive-modal"
    >
      <div v-if="selectedOrder" class="space-y-6">
        <div class="grid grid-cols-2 gap-6 mb-6">
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >平台商户单号</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedOrder.orderId || "-" }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >微信商户单号</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedOrder.wxOrderId || "-" }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >用户信息</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedOrder.unionid || "-" }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >支付金额</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              ¥{{ selectedOrder.amount }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >支付方式</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ getPaymentMethodLabel(selectedOrder.paymentMethod) }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >商品信息</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ selectedOrder.productName }} - {{ selectedOrder.productType }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >创建时间</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ formatOrderTime(selectedOrder.createdAt) }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >支付时间</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{
                selectedOrder.paidAt
                  ? formatOrderTime(selectedOrder.paidAt)
                  : "未支付"
              }}
            </p>
          </div>
          <div class="space-y-2">
            <label class="block text-sm font-semibold text-gray-800"
              >当前状态</label
            >
            <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
              {{ getStatusLabel(selectedOrder.status) }}
            </p>
          </div>
        </div>

        <div v-if="selectedOrder.transactionId" class="space-y-2">
          <label class="block text-sm font-semibold text-gray-800"
            >交易单号</label
          >
          <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
            {{ selectedOrder.transactionId }}
          </p>
        </div>

        <div v-if="selectedOrder.remark" class="space-y-2">
          <label class="block text-sm font-semibold text-gray-800"
            >备注信息</label
          >
          <p class="text-sm text-gray-600 bg-gray-50 px-3 py-2 rounded-md">
            {{ selectedOrder.remark }}
          </p>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeModal">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .responsive-modal :deep(.el-dialog) {
    width: 90vw !important;
    max-width: 90vw !important;
    margin: 5vh auto !important;
    max-height: 90vh !important;
    overflow-y: auto !important;
  }

  .responsive-modal :deep(.el-dialog__body) {
    padding: 16px !important;
    max-height: calc(90vh - 120px) !important;
    overflow-y: auto !important;
  }

  .responsive-modal :deep(.el-dialog__header) {
    padding: 16px 16px 12px !important;
  }

  .responsive-modal :deep(.el-dialog__footer) {
    padding: 12px 16px 16px !important;
  }
}

@media (max-width: 480px) {
  .responsive-modal :deep(.el-dialog) {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 2vh auto !important;
  }

  .responsive-modal :deep(.el-dialog__body) {
    padding: 12px !important;
  }
}

.payment-pagination {
  margin-top: 16px;
  justify-content: flex-start;
}
</style>

<script>
import { getAdminApiUrl } from "@/api/luckdraw.js";
import { getUserToken } from "@/utils/auth.js";

export default {
  name: "PaymentOrders",
  data() {
    return {
      orders: [],
      filteredOrders: [],
      searchParams: {
        unionid: "",
        orderNo: "",
        startTime: null,
        endTime: null,
        status: "2",
      },
      currentPage: 1,
      totalRecords: 0,
      itemsPerPage: 10,
      showModal: false,
      selectedOrder: null,
      loading: false,
    };
  },
  computed: {
    totalOrders() {
      return this.orders.length;
    },
    pendingOrders() {
      return this.orders.filter((order) => order.status === "pending").length;
    },
    paidOrders() {
      return this.orders.filter((order) => order.status === "paid").length;
    },
    cancelledOrders() {
      return this.orders.filter((order) => order.status === "cancelled").length;
    },
    totalPages() {
      return Math.ceil(this.totalRecords / this.itemsPerPage);
    },
    paginatedOrders() {
      return this.orders;
    },
  },
  mounted() {
    this.loadOrders();
  },
  methods: {
    async loadOrders() {
      this.loading = true;

      try {
        const token = getUserToken();
        const url = new URL(
          getAdminApiUrl('/order/search')
        );

        const response = await fetch(url.toString(), {
          method: "POST",
          headers: {
            Token: `${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            page: this.currentPage,
            page_size: this.itemsPerPage,
            pay_status: this.searchParams.status
              ? parseInt(this.searchParams.status)
              : "",
            unionid: this.searchParams.unionid,
            order_id: this.searchParams.orderNo,
            sctime: this.searchParams.startTime
              ? parseInt(this.searchParams.startTime / 1000)
              : "",
            ectime: this.searchParams.endTime
              ? parseInt(this.searchParams.endTime / 1000)
              : "",
          }),
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`获取订单列表失败: ${response.status}`);
        }

        const result = await response.json();

        if (result.sta === 0 && result.data.list) {
          this.totalRecords = result.data.total;
          this.orders = result.data.list.map((order) => ({
            id: order.id,
            orderId: order.order_id,
            orderNo: order.order_id,
            wxOrderId: order.wx_order_id,
            transactionId: order.transaction_id,
            userId: order.user_id,
            unionid: order.unionid,
            username: order.unionid,
            amount: order.total_fee / 100,
            paymentMethod: order.pay_type,
            productName: order.product_name,
            productType: order.product_type,
            status: order.pay_status,
            factor: order.factor,
            mobile: order.mobile,
            createdAt: order.ctime,
            paidAt: order.pay_time,
            remark: order.remark,
          }));
        } else {
          throw new Error(result.msg || "获取订单列表失败");
        }
      } catch (error) {
        console.error("加载支付订单失败:", error);
        this.orders = [
          {
            id: 1,
            orderId: "ORD202401150001",
            orderNo: "ORD202401150001",
            wxOrderId: "WX-MCH-202401150001",
            transactionId: "WX20240115103215",
            userId: "10001",
            unionid: "o-demo-unionid-10001",
            username: "o-demo-unionid-10001",
            amount: "299.00",
            paymentMethod: "wechat",
            productName: "高级会员套餐",
            productType: "会员服务",
            status: "paid",
            createdAt: "2024-01-15T10:30:00Z",
            paidAt: "2024-01-15T10:32:15Z",
            remark: "",
          },
          {
            id: 2,
            orderId: "ORD202401160002",
            orderNo: "ORD202401160002",
            wxOrderId: "WX-MCH-202401160002",
            transactionId: null,
            userId: "10002",
            unionid: "o-demo-unionid-10002",
            username: "o-demo-unionid-10002",
            amount: "99.00",
            paymentMethod: "alipay",
            productName: "基础会员套餐",
            productType: "会员服务",
            status: "pending",
            createdAt: "2024-01-16T14:20:00Z",
            paidAt: null,
            remark: "等待用户支付",
          },
        ];
        this.totalRecords = this.orders.length;

        this.$message.error("加载支付订单失败，使用演示数据");
      } finally {
        this.filteredOrders = [...this.orders];
        this.loading = false;
      }
    },

    handleSearch() {
      this.currentPage = 1;
      this.loadOrders();
    },

    resetSearch() {
      this.searchParams = {
        unionid: "",
        orderNo: "",
        startTime: null,
        endTime: null,
        status: "2",
      };
      this.currentPage = 1;
      this.loadOrders();
    },

    applyFilters() {
      let filtered = [...this.orders];

      if (this.searchParams.unionid) {
        filtered = filtered.filter(
          (order) =>
            order.unionid &&
            order.unionid.toString().includes(this.searchParams.unionid)
        );
      }

      if (this.searchParams.orderNo) {
        filtered = filtered.filter(
          (order) =>
            order.orderNo && order.orderNo.includes(this.searchParams.orderNo)
        );
      }

      if (this.searchParams.status) {
        filtered = filtered.filter(
          (order) => order.status.toString() === this.searchParams.status
        );
      }

      this.filteredOrders = filtered;
    },

    getStatusLabel(status) {
      const statusMap = {
        1: "待支付",
        2: "已支付",
      };
      return statusMap[status] || status;
    },

    getPaymentMethodLabel(method) {
      const methodMap = {
        wechat: "微信支付",
        alipay: "支付宝",
        bank: "银行卡",
        balance: "余额支付",
      };
      return methodMap[method] || method;
    },

    getStatusTagType(status) {
      const tagTypes = {
        1: "warning",
        2: "success",
      };
      return tagTypes[status] || "info";
    },

    getPaymentMethodTagType(method) {
      const tagTypes = {
        wechat: "success",
        alipay: "primary",
        bank: "info",
        balance: "warning",
      };
      return tagTypes[method] || "info";
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    formatOrderTime(value) {
      if (!value) return "-";
      if (typeof value === "number") {
        return this.formatDate(value < 10000000000 ? value * 1000 : value);
      }
      if (/^\d+$/.test(String(value))) {
        const timestamp = Number(value);
        return this.formatDate(
          timestamp < 10000000000 ? timestamp * 1000 : timestamp
        );
      }
      return this.formatDate(value);
    },

    viewOrder(order) {
      this.selectedOrder = order;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.selectedOrder = null;
    },

    async markAsPaid(order) {
      if (confirm(`确定要将订单 ${order.orderNo} 标记为已支付吗？`)) {
        this.loading = true;

        try {
          const token = getUserToken();
          const response = await fetch(
            getAdminApiUrl(`/orders/${order.id}/mark-paid`),
            {
              method: "POST",
              headers: {
                Token: `${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              credentials: "include",
            }
          );

          if (!response.ok) {
            throw new Error(`标记订单失败: ${response.status}`);
          }

          const result = await response.json();

          if (result.sta === 0) {
            order.status = "paid";
            order.paidAt = new Date().toISOString();
            this.applyFilters();
            this.$message.success("订单已标记为已支付！");
          } else {
            throw new Error(result.msg || "标记订单失败");
          }
        } catch (error) {
          console.error("标记订单失败:", error);
          this.$message.error("标记订单失败，请重试");
        } finally {
          this.loading = false;
        }
      }
    },

    async cancelOrder(order) {
      if (confirm(`确定要取消订单 ${order.orderNo} 吗？`)) {
        this.loading = true;

        try {
          const token = getUserToken();
          const response = await fetch(
            getAdminApiUrl(`/orders/${order.id}/cancel`),
            {
              method: "POST",
              headers: {
                Token: `${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              credentials: "include",
            }
          );

          if (!response.ok) {
            throw new Error(`取消订单失败: ${response.status}`);
          }

          const result = await response.json();

          if (result.sta === 0) {
            order.status = "cancelled";
            this.applyFilters();
            this.$message.success("订单已取消！");
          } else {
            throw new Error(result.msg || "取消订单失败");
          }
        } catch (error) {
          console.error("取消订单失败:", error);
          this.$message.error("取消订单失败，请重试");
        } finally {
          this.loading = false;
        }
      }
    },

    refreshData() {
      this.searchParams = {
        unionid: "",
        orderNo: "",
        startTime: null,
        endTime: null,
        status: "2",
      };
      this.currentPage = 1;
      this.loadOrders();
    },

    handleSizeChange(size) {
      this.itemsPerPage = size;
      this.currentPage = 1;
      this.loadOrders();
    },

    handleCurrentChange(page) {
      this.currentPage = page;
      this.loadOrders();
    },
  },
};
</script>
